import { inject, Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { EnvironmentService } from '../services/environment/environment.service';
import { AlertService } from '../services';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class ApplicationInterceptor implements HttpInterceptor {
  readonly SYSTEM_OUT_OF_SERVICE_CODE = 503;
  readonly TOKEN_EXPIRED_CODE = 401;
  readonly CORS_ERROR = 0;

  private readonly environmentService: EnvironmentService =
    inject(EnvironmentService);
  private readonly alertService: AlertService = inject(AlertService);
  private readonly router: Router = inject(Router);
  private readonly matDialog = inject(MatDialog);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const user = JSON.parse(localStorage.getItem('user') || null);
    const token = user
      ? { Authorization: `Bearer ${user.token}`, Token: `Bearer ${user.token}` }
      : null;
    const request = req.clone({
      setHeaders: {
        ...token,
        ambiente: this.environmentService.getAmbiente()?.id || 'developer',
      },
    });
    return next.handle(request).pipe(
      catchError(async (err: HttpErrorResponse) => {
        if (
          [this.SYSTEM_OUT_OF_SERVICE_CODE, this.CORS_ERROR].includes(
            err.status
          )
        ) {
          localStorage.clear();
          this.matDialog.closeAll();
          this.router.navigate(['/authentication/out-of-service']);

          throw err;
        }

        if ([this.TOKEN_EXPIRED_CODE].includes(err.status)) {
          localStorage.clear();
          this.matDialog.closeAll();
          this.router.navigate(['/authentication/login']);

          throw err;
        }

        let message = err.error?.message;

        if (err?.error instanceof Blob) {
          const messageError = await err.error.text();
          message = JSON.parse(messageError || null)?.message || messageError;
        }
        this.alertService.showErrorMessage(message);
        throw err;
      })
    );
  }
}
